<template>
  <div class="respond-message">
    <el-dialog :title="title" :visible.sync="respondDialogVisible" width="30%" @close="update">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <div class="info" v-if="titleType == 3">
          <el-form-item label="用户反馈：">{{resmessage.feedback_content}}</el-form-item>
          <el-form-item label="联系方式：">{{resmessage.mobile}}</el-form-item>
          <el-form-item label="反馈时间：">{{resmessage.created_at}}</el-form-item>
        </div>
        <el-form-item label="发送人角色：" prop="id">
          <el-select class="input-v"
           v-model="form.id"
           filterable
           @change="seachStatus"
           style="width:100%;">
            <el-option
              v-for="(item,index) in roleOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回复内容：" prop="comment_content">
          <el-input
            type="textarea"
            v-model="form.comment_content"
            :autosize="{minRows:3,maxRows:8}"
            placeholder="请输入消息内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="respondDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="send('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
//引入角色列表

import { _adminIndex } from "@/api/admin.js";

import { _commentReply,_userFeedbackInfo } from "@/api/user.js";

import qs from "qs";

const _INFO = function() {
  return {
    name: "",
    comment_content: "",
    id: ""
  };
};

export default {
  created() {
    this.adminIndex();
  },
  props: {
    respondVisible: {
      type: Boolean,
      default: false
    },
    resmessage: {
      type: Object,
      default: {}
    },
    titleType: {
      type: String,
      default: "1"
    }
  },
  computed: {
    title() {
      if (this.titleType == 1) {
        return "回复评论";
      }else if (this.titleType == 3) {
        return "消息推送";
      }
    },
  },
  watch: {
    respondVisible(val) {
      this.respondDialogVisible = val;
    },
    resmessage(val) {
      // console.log(val);
    }
  },
  data() {
    return {
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
      ],
      roleOptions:[],
      respondDialogVisible: false,
      form:_INFO(),
      rules: {
        id: [{ required: true, message: "请选择角色", trigger: "change" }],
        comment_content: [{ required: true, message: "请填写回复内容", trigger: "blur" }]
      }
    };
  },
  methods: {
    update() {
      this.$emit("update:respondVisible", false);
      this.form=_INFO();
    },
    send(formName) {
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitReply();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
     // 获取发送人的头像和昵称
    getUserInfo() {
      let data = this.roleOptions.find(item => {
        if ((this.form.id == item.id)) {
          return item;
        }
      });
      return data;
    },
    //状态查询信息
    seachStatus(val) {
      // console.log(val);
      // this.form.id = val;
    },
     //加载员工列表
    adminIndex() {
      _adminIndex({
        params: {
          role_id:1
        }
      }).then(res => {
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.roleOptions = data.map(item => {
            return {
              name: item.name,
              id: item.id,
              user_nick_name:item.name,
              user_pfrofile_photo:item.head_img
            };
          });
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    submitReply(){
      // 提交信息
      if(this.titleType == 1){
        this.commentReply();
      }else if(this.titleType == 3){
        this.userFeedbackInfo();
      }
    },
    //评论回复
    commentReply() {
      _commentReply({
        data: qs.stringify({
          replied_comment_id: this.resmessage.comment_id,
          comment_content: this.form.comment_content,
          user_pfrofile_photo: this.getUserInfo().user_pfrofile_photo,
          user_nick_name: this.getUserInfo().user_nick_name
        })
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.$emit("uploadInfo", true);
          this.respondDialogVisible = false;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //反馈回复
    userFeedbackInfo(){
       _userFeedbackInfo({
        data: qs.stringify({
          replied_feedback_id:this.resmessage.feedback_id,
          replied_user_id:this.resmessage.user_id,
          feedback_content: this.form.comment_content,
          user_pfrofile_photo: this.getUserInfo().user_pfrofile_photo,
          user_nick_name: this.getUserInfo().user_nick_name
        })
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.$emit("uploadInfo", true);
          this.respondDialogVisible = false;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  }
};
</script>


<style lang="less" scoped>
</style>
